import React from 'react'

import Iframe from 'react-iframe'

import {
  FacebookEvent,
} from '../../constants'

import store from '../../store'

class ConnectionVerifierFacebook extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      loading: true,
    }

    this.onReceiveLoginData = this.onReceiveLoginData.bind(this)
  }

  componentDidMount() {
    document.addEventListener(FacebookEvent.RECEIVE.GET_USER_INFO, this.onReceiveLoginData)
  }

  componentWillUnmount() {
    document.removeEventListener(FacebookEvent.RECEIVE.GET_USER_INFO, this.onReceiveLoginData)
  }

  onReceiveLoginData(e) {
    document.removeEventListener(FacebookEvent.RECEIVE.GET_USER_INFO, this.onReceiveLoginData)

    const data = e.detail.data
    this.setState({
      loading: false
    })
    
    store.setUserDetailsFacebook(data)

    if (this.props.onReceiveLoginData) {
      this.props.onReceiveLoginData(data)
    }  
  }

  render() {
    return (
      this.state.loading ?
      <Iframe 
        id='iframe-facebook'
        url={`https://m.facebook.com/me?${FacebookEvent.SEND.GET_USER_INFO}=1`}
        width={1} 
        height={1}
        display="hidden" 
        position="relative"
      /> : null
    )
  }
}

export default ConnectionVerifierFacebook